import React, { FunctionComponent, useCallback, useMemo } from "react"
import { useHistory, useRouteMatch } from "react-router"
import { Link } from "react-router-dom"
import DotButton from "../../components/Buttons/DotButton"
import { getUserRoutes } from "./inspector/routes"

interface iProps {
  title: string
  handleSubmit?: () => void
  isLoading?: boolean
}

const UserHeader: FunctionComponent<iProps> = ({
  title,
  handleSubmit,
  isLoading = false,
}) => {
  const match = useRouteMatch()
  const history = useHistory()
  const navRoutes = useMemo(() => getUserRoutes({ urlPrefix: match.url }), [
    match.url,
  ])

  const handleHisoryBack = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    history.goBack()
  }, [])

  return (
    <div className="inspector-header">
      <div className="inspector-cover-wrap">
        <div className="inspector-cover-overlay">
          <div className="inspector-headline align-items-start">
            <Link to={""} onClick={handleHisoryBack}>
              <i className="fa fa-chevron-left"></i>
              <span>Back</span>
            </Link>
            <div className="d-flex">
              <DotButton
                className={`btn-blue submit-button`}
                onClick={handleSubmit}
                type="button"
                isLoading={isLoading}
                text={"Update"}
              />
            </div>
          </div>
          <h1 className="inspector-title">{title}</h1>
        </div>
      </div>
      <div className="inspector-navigation">
        <ul>
          {navRoutes.map((n, i) => (
            <li
              key={i}
              className={history.location.pathname === n.route ? "active" : ""}
            >
              <Link to={n.route} replace>
                <span>{n.title} </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default UserHeader
